<div class="row p-1 blue">
  <div class="col-12 pageTitle">
      <h2>&nbsp;&nbsp;&nbsp;User Practice List</h2>
  </div>
</div>

<div class="card">
  <div class="p-fluid formgrid grid">
    <div class="field col-12 md:col-4">
      <span class="p-float-label">
        <input
          id="float-input"
          pInputText
          [(ngModel)]="lastName"
          type="text"
          class="textboxBorder-1"
        />
        <label for="float-input" class="f1">Last Name</label>
      </span>
    </div>

    <div class="field col-12 md:col-4">
      <span class="p-float-label">
        <input
          id="float-input"
          pInputText
          [(ngModel)]="firstName"
          type="text"
          class="textboxBorder-1"
        />
        <label for="float-input" class="f1">First Name</label>
      </span>
    </div>

    <span class="pt-1">
      &nbsp;
      <button
        pButton
        type="button"
        icon="pi pi-search"
        label="Search"
        (click)="getUserList(1, '', '')"
        class="ui-button-plain buttonWidth-8 ml-3"
      ></button>
      &nbsp;<button
        pButton
        label="Clear"
        severity="secondary"
        icon="pi pi-refresh"
        class="buttonWidth-8 fl ml-1 GreyButton"
        (click)="clearUserList()"
      ></button>
    </span>
  </div>
</div>

<p-table
  *ngIf="users"
  [resetPageOnSort]="false"
  lazy="true"
  (onLazyLoad)="nextPage($event)"
  [totalRecords]="users.totalRecords"
  [currentPageReportTemplate]="'{currentPage} of {totalPages}'"
  [columns]="cols"
  [alwaysShowPaginator]="false"
  [rows]="rows"
  [paginator]="true"
  [value]="users.data"
  selectionMode="single"
  [sortOrder]="1"
  sortField="loginId"
  [(selection)]="selectedUser"
  dataKey="userId"
>
  <ng-template pTemplate="header" let-columns>
    <tr *ngIf="Showrecords == true">
      <ng-template ngFor let-col [ngForOf]="columns" let-i="index">
        <th *ngIf="col.sort == true" [pSortableColumn]="col.field">
          {{ col.header }}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
        <th *ngIf="col.sort == false">
          {{ col.header }}
        </th>
      </ng-template>

      <th class="col-12 md:col-1" style="text-align: center !important">
        Active
      </th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <td *ngFor="let col of columns">
        <div
          *ngIf="col.subfield; then nested_object_content; else normal_content"
        ></div>
        <ng-template #nested_object_content>
          {{ rowData[col.field][col.subfield] }}
        </ng-template>
        <ng-template #normal_content>
          {{ rowData[col.field] }}
        </ng-template>
      </td>

      <td style="text-align: center !important">
        <span *ngIf="rowData['status'] == 'YES'; else falsy">
          <button
            pButton
            pRipple
            icon="pi pi-check"
            class="p-button-rounded p-button-success"
          ></button>
        </span>
        <ng-template #falsy>
          <span>
            <button
              pButton
              pRipple
              icon="pi pi-times"
              class="p-button-rounded p-button-danger"
            ></button>
          </span>
        </ng-template>
      </td>

      <td>
        <button
          pButton
          type="button"
          icon="pi pi-map"
          class="p-button-plain"
          pTooltip="click to map"
          style="font-size: 0.7em"
          (click)="onAddPractice(rowData['userId'])"
        ></button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <div class="w-12 bg-white">
      <div class="" style="text-align: center">
        <img
          _ngcontent-ng-c683320295=""
          class="profile-image"
          style="border-radius: 50%; width: 10rem; padding-top: 1rem"
          src="assets/imagesNew/table_error.png"
        />
      </div>
      <hr style="margin-bottom: 0.5rem" />
      <div
        class=""
        style="text-align: center; font-size: larger; color: #1d428f"
      >
        <i>No records found</i>
      </div>
    </div>
  </ng-template>
</p-table>

<div>
  <p-dialog
    [(visible)]="displayAddPractices"
    [draggable]="true"
    [modal]="true"
    [responsive]="true"
    [style]="{ width: '450px', minWidth: '200px' }"
    [minY]="70"
    [maximizable]="true"
    [baseZIndex]="10000"
  >
    <p-header> Map User Practices </p-header>

    <p-pickList
      [source]="sourcePractice"
      [target]="targetPractice"
      sourceHeader="Available"
      targetHeader="Selected"
      [dragdrop]="true"
      [responsive]="true"
      filterBy="name"
    >
      <ng-template let-practice pTemplate="item">
        <div class="practice-item">
          <div class="practice-list-detail">
            <h5 class="mb-2">{{ practice.name }}</h5>
          </div>
        </div>
      </ng-template>
    </p-pickList>
    <div style="display: flex; justify-content: center" class="pt-3">
      <button
        pButton
        type="button"
        icon="pi pi-save"
        label="Save"
        class="p-button-plain blueGradient mr-4"
        (click)="setUserpractices()"
      ></button>
      <button
        pButton
        type="button"
        icon="pi pi-times-circle"
        (click)="displayAddPractices = false"
        label="Cancel"
        class="p-button-plain GreyButton"
      ></button>
    </div>
  </p-dialog>
</div>
